import React from 'react';
import language from '@language';

export default class Success extends React.Component<any> {
    constructor(props) {
        super(props);
    }

    render() {
        const { fields, country } = this.props;
        const isMarocco = country == 'MA';
        return (
            <div>
                <div className="payment-details">
                    <div className="clock-box">
                        <p>
                            <i className="fa fa-clock-o" /> {language.claim_sended}
                        </p>
                    </div>
                    <table>
                        <tbody>
                            <tr>
                                <td>{language.client_number}</td>
                                <td>{fields.client_number}</td>
                            </tr>
                            <tr>
                                <td>{language.property_name}</td>
                                <td>{fields.property_name}</td>
                            </tr>
                            <tr>
                                <td>{language.holder_name}</td>
                                <td>{fields.holder_name}</td>
                            </tr>
                            {!isMarocco && (
                                <tr>
                                    <td>{language.document}</td>
                                    <td>{fields.document}</td>
                                </tr>
                            )}
                            <tr>
                                <td>{language.email}</td>
                                <td>{fields.email}</td>
                            </tr>
                            <tr>
                                <td>{language.invoice_number}</td>
                                <td>{fields.invoice_number}</td>
                            </tr>
                            <tr>
                                <td>{language.amount}</td>
                                <td>${fields.amount}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
